// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__1JeZt","text":"Home_text__1B_gY","wrappedText":"Home_wrappedText__2NVsC"};